export class ProductGroupReq{
    productGroupId:number
}